import { c as _c } from "react/compiler-runtime";
import { FormSelectDataType } from '@systemeio/ui';
import { CAMPAIGNS_API } from 'modules/campaigns/api/constants';
import { AfterCampaignStepList, CampaignStepId } from 'modules/campaigns/campaign-steps/types/campaign-step-interface';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import { useEffect, useState } from 'react';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
interface UseAfterCampaignStepsSelectOptionsInterface {
  campaignId: CampaignId;
  campaignStepId: CampaignStepId;
}
export function useAfterCampaignStepsSelectOptions(t0) {
  const $ = _c(11);
  const {
    campaignId,
    campaignStepId
  } = t0;
  const {
    user
  } = useUser();
  const [afterCampaignStepsNamesSelectOptions, setAfterCampaignStepsNamesSelectOptions] = useState(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== campaignId || $[2] !== user) {
    t2 = () => user && [`${CAMPAIGNS_API}/${campaignId}/steps/list-all`, RequestModuleEnum.CampaignStep];
    $[1] = campaignId;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data,
    mutate: mutateAfterCampaignStepsSelectOptions
  } = useControlledSwr(t2, fetcher);
  let t3;
  let t4;
  if ($[4] !== campaignStepId || $[5] !== data) {
    t3 = () => {
      if (data) {
        setAfterCampaignStepsNamesSelectOptions([...data.filter(t5 => {
          const {
            id
          } = t5;
          return id !== campaignStepId;
        }).map(_temp)]);
      }
    };
    t4 = [campaignStepId, data];
    $[4] = campaignStepId;
    $[5] = data;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== afterCampaignStepsNamesSelectOptions || $[9] !== mutateAfterCampaignStepsSelectOptions) {
    t5 = {
      afterCampaignStepsNamesSelectOptions,
      mutateAfterCampaignStepsSelectOptions
    };
    $[8] = afterCampaignStepsNamesSelectOptions;
    $[9] = mutateAfterCampaignStepsSelectOptions;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(campaignStep) {
  return {
    id: campaignStep.id,
    caption: campaignStep.mailing.currentEmail.subject
  };
}